import { render, staticRenderFns } from "./MySchedulings.vue?vue&type=template&id=4bedf661&"
import script from "./MySchedulings.vue?vue&type=script&lang=js&"
export * from "./MySchedulings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports